<template>
  <f7-page name="vodne-stavy" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Vodné stavy</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-vt-map" tab-link-active>Mapa</f7-link>
      <f7-link tab-link="#tab-vt-table" >Zoznam</f7-link>
      <f7-link tab-link="#tab-vt-pa-table">PA</f7-link>
    </f7-toolbar>
    <f7-tabs class="wh-100">
      <f7-tab id="tab-vt-map" tab-active @tab:show="onMapTabShow($event)">
        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapVt"
               class="vt-map"
        >
          <l-control-zoom position="bottomright"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />
          <l-tile-layer :url="riversUrl" :opacity="0.5" />


          <l-marker-cluster :options="clusterOptions" ref="clusterRef">
            <l-geo-json v-for="geoJson in vtGeoJsonData.features" :key="geoJson.id" :geojson="geoJson" :options="vtGeoJsonOptions"></l-geo-json>
            <!--l-geo-json
                :geojson="vtGeoJsonData"
                :options="vtGeoJsonOptions"
            /-->
          </l-marker-cluster>

          <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
            </div>
          </l-control>

          <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
            </div>
          </l-control>
          


        </l-map>
      </f7-tab>
      <f7-tab id="tab-vt-table" @tab:show="onTableTabShow($event)">
        <f7-block strong class="no-padding no-margin no-border-top">
          <f7-searchbar
              search-container=".search-list"
              search-in=".item-title, .item-subtitle"
              placeholder="Hľadať..."
              disable-button-text="Zrušiť"
              :remove-diacritics="true"
              :disable-button="!$theme.aurora"
          ></f7-searchbar>
          <f7-block strong class="no-margin vt-s-buttons">
            <f7-segmented raised tag="p">
              <f7-button @click="setRegionActive('')" :class="{'button-active': isAllActive}" >Všetky</f7-button>
              <f7-button @click="setRegionActive('BA')" :class="{'button-active': isBAActive}">BA</f7-button>
              <f7-button @click="setRegionActive('ZA')" :class="{'button-active': isZAActive}">ZA</f7-button>
              <f7-button @click="setRegionActive('BB')" :class="{'button-active': isBBActive}">BB</f7-button>
              <f7-button @click="setRegionActive('KE')" :class="{'button-active': isKEActive}">KE</f7-button>
            </f7-segmented>

          </f7-block>
          <f7-list class="searchbar-not-found no-margin-top">
            <f7-list-item title="Nič nebolo nájdené..." subtitle="Skúste zmeniť parametre vyhľadávania..."></f7-list-item>
          </f7-list>
          <f7-list media-list class="search-list searchbar-found no-margin-top vodnestavy">
            <f7-list-item v-for="(item, index) in this.stationsSorted" :key="index"
                          v-if="item.data"
                          :no-chevron="true"
                          :link="'/vodne-stavy/'+item.id_station"
                          :class="'vt-spa-'+item.data.pa + ' vt-ack-'+item.data.ack"
            >
              <div class="item-title-row">
                <div class="item-title">{{ item.station_name + ' - ' + item.river_name}}</div>
                <div class="item-after">
                  <span>{{ item.data.hladina + ' cm'}} <span v-html="getStavIcon(item.data)"></span></span>
                </div>
              </div>
              <div class="item-subtitle">ID: {{ item.id_station }}, RS: {{ item.region }}, Okres: {{ item.okres.nazov }}</div>
              <div class="item-footer">
                Dátum merania: {{ item.data.dt*1000 | moment('DD.MM.YYYY HH:mm') }}
              </div>
            </f7-list-item>
          </f7-list>



        </f7-block>
      </f7-tab>
      <f7-tab id="tab-vt-pa-table" @tab:show="onPaTableTabShow($event)">
        <f7-block-title class="mt-1">Povodňová aktivita</f7-block-title>
        <f7-block strong class="no-padding no-margin no-border-top" v-if="this.stationsWithPa.length > 0">
          <f7-list media-list class="no-margin-top vodnestavy">
            <f7-list-item v-for="(item, index) in this.stationsWithPa" :key="index"
                          :no-chevron="true"
                          :class="'vt-spa-'+item.data.pa + ' vt-ack-'+item.data.ack"
                          :link="'/vodne-stavy/'+item.id_station"
            >
              <div class="item-title-row">
                <div class="item-title">{{ item.station_name + ' - ' + item.river_name}}</div>
                <div class="item-after">
                  <span>{{ item.data.hladina + ' cm'}} <span v-html="getStavIcon(item.data)"></span></span>
                </div>
              </div>
              <div class="item-subtitle">ID: {{ item.id_station }}, RS: {{ item.region }}, Okres: {{ item.okres.nazov }}</div>
              <div class="item-footer">
                Dátum merania: {{ item.data.dt*1000 | moment('DD.MM.YYYY HH:mm') }}
              </div>
            </f7-list-item>

          </f7-list>
        </f7-block>
        <f7-block v-else class="text-align-center no-margin-top padding bg-color-green">
          Aktuálne nie je prekročený žiaden stupeň povodňovej aktivity.
        </f7-block>
      </f7-tab>

    </f7-tabs>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LTriangleMarker} from "leaflet-triangle-marker";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom, LControl } from 'vue2-leaflet';
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import 'leaflet/dist/leaflet.css';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

import vtChart from './vodne-stavy-chart-options'
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";

var icn_markers = [];

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LTriangleMarker,
    LControlZoom,
    LControl,
    'l-marker-cluster': Vue2LeafletMarkerCluster,
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      latestData: [],
      isDataLoaded: false,
      stations: [],
      isStationsLoaded: false,
      lastUpdated: 0,
      lastUpdatedData: 0,
      tCheckInterval: null,
      tCheckIntervalData: null,
      isAllActive: true,
      isBAActive: false,
      isZAActive: false,
      isBBActive: false,
      isKEActive: false,
      allStations: [],
      baStations: [],
      zaStations: [],
      bbStations: [],
      keStations: [],

      chartOptions: vtChart,
      vtGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      vtGeoJsonOptions: {
        onEachFeature:this.openVtDetailFromFeature,
        pointToLayer: this.makeVtPoint,
      },
      vtMarkers: [],
      clusterOptions: {
        disableClusteringAtZoom: 9,
        zoomToBoundsOnClick: false,
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: false,
        iconCreateFunction: cluster => {

          let vals = [];
          cluster.getAllChildMarkers().forEach( marker => {
            let val = marker.feature.properties.pa;
            if (val !== null) {
              vals.push(val)
            }
          });


          let class_name = 'cluster-base-color';

          if (vals.length > 0) {
            let avg = vals.reduce((a, b) => a + b, 0);
            let highest = vals.sort((a, b) => b - a)[0];
            class_name = this.getColorClass(highest);
          }


          let pocet = cluster.getChildCount();
          let p_text = 'staníc';
          if (pocet === 1) p_text = 'stanica';
          if (pocet > 1) p_text = 'stanice';
          if (pocet >= 5) p_text = 'staníc';
          return L.divIcon({
            className: 'cluster-icon ' + class_name,
            iconSize: 45,
            html: pocet + '&nbsp; <small style="font-weight:normal; font-size:8px;">'+p_text+'</small>',
          });
        },

      },
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',


      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  watch: {
    latestData() {
      // priradime data k staniciam
      this.stations.forEach(item => {
        let station_data = this.getStationData(item.id_station);
        if (station_data) {
          item.data = station_data;
        }
      });

      let ba = this.stations.filter((item) => item.region === 'BA');
      this.baStations = ba.sort((a, b) => a.id_station - b.id_station);

      let za = this.stations.filter((item) => item.region === 'ZA');
      this.zaStations = za.sort((a, b) => a.id_station - b.id_station);

      let bb = this.stations.filter((item) => item.region === 'BB');
      this.bbStations = bb.sort((a, b) => a.id_station - b.id_station);

      let ke = this.stations.filter((item) => item.region === 'KE');
      this.keStations = ke.sort((a, b) => a.id_station - b.id_station);

      this.allStations = this.baStations.concat(this.zaStations, this.bbStations, this.keStations);

    }
  },
  computed: {
    stationsSorted: function() {

      if (this.isAllActive) {
        return this.allStations;
      } else if (this.isBAActive) {
        return this.baStations;
      } else if (this.isZAActive) {
        return this.zaStations;
      } else if (this.isBBActive) {
        return this.bbStations;
      } else if (this.isKEActive) {
        return this.keStations;
      }

    },
    stationsWithPa: function() {
      return this.allStations.filter(item => (item.data && item.data.pa > 0 && item.data.ack === 1));
    },

  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
    clearInterval(this.tCheckIntervalData);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    setRegionActive: function(region) {
      if (region === 'BA') { this.isAllActive=false; this.isBAActive=true; this.isZAActive = false; this.isBBActive = false; this.isKEActive = false; }
      else if (region === 'ZA') { this.isAllActive=false; this.isBAActive=false; this.isZAActive = true; this.isBBActive = false; this.isKEActive = false; }
      else if (region === 'BB') { this.isAllActive=false; this.isBAActive=false; this.isZAActive = false; this.isBBActive = true; this.isKEActive = false; }
      else if (region === 'KE') { this.isAllActive=false; this.isBAActive=false; this.isZAActive = false; this.isBBActive = false; this.isKEActive = true; }
      else { this.isAllActive = true; this.isBAActive=false; this.isZAActive = false; this.isBBActive = false; this.isKEActive = false; }
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadVtGeoJsonData();
      }

      if (!isInit && (this.$moment().unix() - this.lastUpdatedData) > 60) {
        this.loadStations();
      }


    },
    loadStations() {
      //console.log('loadStations')
      const self = this;

      let cached_stations = self.$ls.get('vt_stations');
      if (cached_stations !== null) {
        self.stations = Object.freeze(cached_stations);
        self.isStationsLoaded = true;
        this.loadLatestData();
      } else {

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getvtstations', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.stations = Object.freeze(response.data);
                self.$ls.set('vt_stations', self.stations, 24 * 60 * 60 * 1000); // 1 den
                self.isStationsLoaded = true;
                this.loadLatestData();
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať zoznam vodomerných staníc', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    loadLatestData() {
      const self = this;
      //console.log('loadLatestData')
      let cached_latest_data = self.$ls.get('vt_latest_data');
      if (cached_latest_data !== null) {
        self.latestData = Object.freeze(cached_latest_data);
        self.isDataLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getvtlatestdata', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.latestData = Object.freeze(response.data);
                self.isDataLoaded = true;
                self.$ls.set('vt_latest_data', self.latestData, 2 * 60 * 1000); // 5 minut
                self.lastUpdatedData = self.$moment().unix();
                // clearInterval(this.tCheckIntervalData);
                // this.tCheckIntervalData = setInterval(this.checkLastUpdatedData, 5 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne vodné stavy', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    loadVtGeoJsonData: function() {
      const self = this;
      //console.log('loadVtGeoJsonData')

      let cached_geojson = self.$ls.get('vt_geojson');
      if (cached_geojson !== null) {
        self.vtGeoJsonData = Object.freeze(cached_geojson);
        self.isGeoJsonLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getvtgeojson', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.vtGeoJsonData = Object.freeze(response.data);
                self.isGeoJsonLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('vt_geojson', self.vtGeoJsonData, 2 * 60 * 1000); // 5 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne vodné stavy do mapy', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    getStationById: function(station_id) {
      if (this.stations) {
        return this.stations.find((item) => parseInt(item.id_station) === parseInt(station_id))
      }
      return false;
    },
    getStationData: function(station_id) {
      if (this.latestData) {
        return this.latestData.find((item) => parseInt(item.id_station) === parseInt(station_id))
      }
      return false;
    },
    getStavIcon: function(item) {
      if (parseInt(item.stav) ===0) return ' <i class="f7-icons text-color-lightblue">minus</i>'
      else if (parseInt(item.stav) === 1) return ' <i class="f7-icons text-color-red stav-1">arrowtriangle_up_fill</i>'
      else if (parseInt(item.stav) === -1) return ' <i class="f7-icons text-color-green">arrowtriangle_down_fill</i>'
      else return ' <i class="f7-icons text-color-lightblue">question</i>'

    },
    initMap() {
      const self = this;
      //this.$refs.mapVt.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet VT init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapVt.mapObject);

      /*
      this.$refs.mapVt.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });

       */




    },
    onMapTabShow(e) {
      this.$refs.mapVt.mapObject.invalidateSize();
    },
    onPaTableTabShow(e) {
      this.loadStations();
    },
    onTableTabShow(e) {
      this.loadStations();
    },
    makeVtPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      let width = 1;
      let radius = 6;
      let angle = 0;
      let points = 4;
      if (props.has_forecast === true) { width = 2; }

      let fillColor = 'rgba(74,142,3,1)';
      let spa = parseInt(props.pa);
      if (spa === 1) fillColor = 'rgba(255,255,0,1)';
      else if (spa === 2) fillColor = 'rgba(255,153,0,1)';
      else if (spa === 3) fillColor = 'rgba(255,31,0,1)';

      if (parseInt(props.stav) === 1) { angle = 0;  }
      else if (parseInt(props.stav) === -1) { angle = 180;  }

      let point;

      if (parseInt(props.stav) === 0)
      {
        point = L.circleMarker(latlng, {
          radius: radius,
          fillColor: fillColor,
          color: "#000",
          weight: width,
          opacity: 1,
          fillOpacity: 0.9
        });
      } else {

        point = L.triangleMarker(latlng, {
          radius: radius,
          fillColor: fillColor,
          color: "#000",
          width: 12,
          rotation: angle,
          height: 8,
          weight: width,
          opacity: 1,
          fillOpacity: 0.9
        });
      }

      let map = this.$refs.mapVt.mapObject;


      /*
      let myIcon = L.divIcon({className: 'i-label', html:props.name, iconAnchor:[100,30]});
      icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      icn_markers[feature.id]._icon.id = 'station' + feature.id;
      icn_markers[feature.id].on({
        click: function (e) {
          let station_id = e.target._icon.id.replace('station','');
          //    console.log('label clicked', station_id);
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/vodne-stavy/' + station_id);
          }
        }
      });

       */



      return point;
    },
    openVtDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          let station_id = v.target.feature.id;
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/vodne-stavy/' + station_id);
          }
        }
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    checkLastUpdatedData() {
      if ((this.$moment().unix() - this.lastUpdatedData) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    getColorClass(val) {
      let class_name = 'spa-0';
      let spa = parseInt(val);
      if (spa === 1) class_name = 'spa-1';
      else if (spa === 2) class_name = 'spa-2';
      else if (spa === 3) class_name = 'spa-3';
      return class_name;

    },
    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapVt.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapVt.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapVt.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }

  }

};
</script>

<style lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.spa-0 {
  background-color: rgba(74,142,3,0.8);
  color: #fff;
}
.spa-1 {
  background-color: rgba(255,255,0,0.8);
  color: #000;
}
.spa-2 {
  background-color: rgba(255,153,0,0.8);
  color: #000;
}
.spa-3 {
  background-color: rgba(255,31,0,0.8);
  color: #fff;
}

.vodnestavy {
  .item-after {
    color: var(--f7-color-primary);
    font-weight:bold;
    .f7-icons {
      font-size:1rem;
    }
  }
  .item-title {
    font-size: 0.9rem;
  }
  .item-subtitle {
    color: var(--f7-list-item-footer-text-color);
    font-size: var(--f7-list-item-footer-font-size);
  }

  .vt-ack-1.vt-spa-1 {
    background-color: yellow !important;
  }

  .vt-ack-1.vt-spa-2 {
    background-color: orange !important;
  }

  .vt-ack-1.vt-spa-3 {
    background-color: red !important;
    color: white !important;
    .item-title,
    .item-subtitle,
    .item-footer {
      color: white !important;
    }
    .item-after {
      .f7-icons.stav-1 {
        color: var(--f7-color-red-tint) !important;
      }
    }
  }

}

.vt-map {
  width: 100%;
  height: 100%;
}

.vt-s-buttons {
  padding: 0.5rem;
  .button {
    font-size: 0.7rem;
  }
}
#tab-vt-map {
  height:100%;
  width:100%;
}



.vt-cluster-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(48, 72, 107, 0.3);
  font-size: 1em;
  font-weight: bold;
}

.vt-cluster-base-color {
  background: rgba(74,142,3,1);
  color: #fff;
}



</style>
